import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import checkScope from "../middlewares/scope";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/unity_video_call",
    name: "unity_video_call",
    component: () => import("../views/UnityVideoCall.vue"),
  },
  {
    path: "/video_call",
    name: "video_call",
    component: () => import("../views/ParticipantVideoCall.vue"),
  },
  {
    path: "/video_call_ended",
    name: "video_call_ended",
    component: () => import("../views/ParticipantEndVideoCall.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: async (to, from, next) => {
      if (await store.dispatch("auth/checkToken")) {
        next(from.path);
      } else {
        next();
      }
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/",
    name: "",
    component: Home,
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("../views/Dashboard.vue"),
      },
      {
        path: "roles",
        name: "roles",
        beforeEnter: checkScope("auth.roles.read"),
        component: () => import("../views/Roles.vue"),
      },
      {
        path: "scopes",
        name: "scopes",
        beforeEnter: checkScope("auth.scopes.read"),
        component: () => import("../views/Scopes.vue"),
      },
      {
        path: "letters",
        name: "letters",
        beforeEnter: checkScope("letters.read"),
        component: () => import("../views/Letters.vue"),
      },
      {
        path: "teams",
        name: "teams",
        beforeEnter: checkScope("teams.read"),
        component: () => import("../views/Teams.vue"),
      },
      {
        path: "teams/new",
        name: "teams_new",
        beforeEnter: checkScope("teams.add"),
        component: () => import("../views/TeamsForm.vue"),
      },
      {
        path: "teams/:id",
        name: "teams_update",
        beforeEnter: checkScope("teams.edit"),
        component: () => import("../views/TeamsForm.vue"),
      },
      {
        path: "leads",
        name: "leads",
        beforeEnter: checkScope("leads.read"),
        component: () => import("../views/Leads.vue"),
      },
      {
        path: "leads/ops",
        name: "lead_not_found",
        component: () => import("../views/LeadNotFound.vue"),
      },
      {
        path: "leads/:lead_number",
        beforeEnter: checkScope("leads.read"),
        component: () => import("../views/LeadDetail.vue"),
        children: [
          {
            path: "/",
            name: "lead_detail_data",
            component: () => import("../components/Lead/DataTab.vue"),
          },
          {
            path: "policy",
            name: "lead_detail_policy",
            component: () => import("../components/Lead/PolicyTab.vue"),
          },
          {
            path: "product/:product_id",
            name: "edit_product",
            beforeEnter: checkScope("leads.products.edit"),
            component: () => import("../components/Lead/ProductForm.vue"),
          },
          {
            path: "scheduling",
            beforeEnter: checkScope("leads.schedulings.read"),
            component: () => import("../components/Lead/SchedulingTab.vue"),
            children: [
              {
                path: "/",
                name: "lead_detail_scheduling_list",
                component: () =>
                  import("../components/Lead/Scheduling/SchedulingList.vue"),
              },
            ],
          },
          {
            path: "comments",
            name: "lead_detail_comments",
            beforeEnter: checkScope("leads.comments.read"),
            component: () => import("../components/Lead/CommentsTab.vue"),
          },
          {
            path: "files",
            name: "lead_detail_files",
            beforeEnter: checkScope("leads.attachments.read"),
            component: () => import("../components/Lead/FilesTab.vue"),
          },
          {
            path: "integration",
            name: "integration",
            beforeEnter: checkScope("leads.integration.read"),
            component: () => import("../components/Lead/Integration.vue"),
          },
          {
            path: "damages",
            name: "damages",
            beforeEnter: checkScope("leads.damages.read"),
            component: () => import("../components/Lead/DamagesTab.vue"),
          },
        ],
      },
      {
        path: "contacts",
        name: "contacts",
        beforeEnter: checkScope("contacts.read"),
        component: () => import("../views/Contacts.vue"),
      },
      {
        path: "unities",
        name: "unities",
        beforeEnter: checkScope("unities.read"),
        component: () => import("../views/Unities.vue"),
      },
      {
        path: "contacts/new",
        name: "contacts-new",
        beforeEnter: checkScope("contacts.add"),
        component: () => import("../views/NewContact.vue"),
      },
      {
        path: "users",
        name: "users",
        beforeEnter: checkScope("auth.users.read"),
        component: () => import("../views/Users.vue"),
      },
      {
        path: "perfil",
        name: "perfil",
        component: () => import("../views/Profile.vue"),
      },
      {
        path: "devzone",
        name: "devzone",
        component: () => import("../views/DevZone"),
      },
      {
        path: "my_schedulings",
        name: "my_schedulings",
        beforeEnter: checkScope("leads.my_schedulings.read"),
        component: () => import("../views/MySchedulings.vue"),
      },
      {
        path: "managers",
        name: "managers",
        beforeEnter: checkScope("service_managers.read"),
        component: () => import("../views/Managers.vue"),
      },
      {
        path: "image_predict",
        name: "image_predict",
        component: () => import("../views/ImagePredict.vue"),
      },
      {
        path: "i18n",
        name: "i18n",
        beforeEnter: checkScope("internationalization.read"),
        component: () => import("../views/i18n.vue"),
      },
      {
        path: "budgets",
        name: "Budgets",
        component: () => import("../views/Budgets/Budgets.vue"),
      },
      {
        path: "budgets/:budget",
        name: "BudgetPage",
        component: () => import("../views/Budgets/BudgetPage.vue"),
        props: true,
      },
      {
        path: "budgets/:budget/da",
        name: "BudgetDaPage",
        component: () => import("../views/Budgets/BudgetDAPage.vue"),
      }
    ],
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "*",
    component: Home,
    beforeEnter: (to, from, next) => {
      next("/");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
